export default "__VITE_ASSET__jXbOpfmO__"